import { render, staticRenderFns } from "./global_block_page.vue?vue&type=template&id=e5926230&scoped=true&"
import script from "./global_block_page.vue?vue&type=script&lang=js&"
export * from "./global_block_page.vue?vue&type=script&lang=js&"
import style0 from "./global_block_page.vue?vue&type=style&index=0&id=e5926230&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e5926230",
  null
  
)

/* custom blocks */
import block0 from "./global_block_page.vue?vue&type=custom&index=0&blockType=route"
if (typeof block0 === 'function') block0(component)

export default component.exports